import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `ValidateContentRoot`,
  grid: `ValidateContentGrid`
};

export function useValidateContentStyles() {
  const { effects, spacing, semanticColors } = useTheme();
  const styles = useMemo(
    () => mergeStyleSets({
      root: [classNames.root, { height: `100%` }],
      grid: [classNames.grid, { boxShadow: effects.elevation8, padding: `15px` }]
    }),
    [effects]
  );

  const gridStyles = useMemo(
    () => mergeStyleSets({
      label: {
        width: `168px`
      },
      headerWrap: {
        marginBottom: `4px`,
        padding: `${spacing.m} ${spacing.s1} ${spacing.m} 158px`
      },
      header: {},
      row: {
        minHeight: `42px`,
        padding: spacing.s1
      },
      rowAlt: {
        backgroundColor: semanticColors.listItemBackgroundHovered,
        minHeight: `42px`,
        padding: spacing.s1
      },
      value: {
        paddingBottom: `3px`,
        paddingLeft: `12px`
      }
    }),
    [semanticColors, spacing]
  );

  return { styles, gridStyles };
}
